
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AddCandidateForm } from './AddCandidateForm';
import { useCreateCandidate } from '@/hooks/mutations/useCreateCandidate';
import type { NewCandidateFormData } from './types';

interface AddCandidateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCandidateCreated?: (candidateId: string) => void;
}

export const AddCandidateDialog: React.FC<AddCandidateDialogProps> = ({
  open,
  onOpenChange,
  onCandidateCreated,
}) => {
  const { createCandidate, isCreatingCandidate } = useCreateCandidate();

  const handleSubmit = (data: NewCandidateFormData) => {
    createCandidate(data, {
      onSuccess: (candidate) => {
        onCandidateCreated?.(candidate.id);
        onOpenChange(false);
      },
    });
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add New Candidate</DialogTitle>
        </DialogHeader>
        <AddCandidateForm
          onSubmit={handleSubmit}
          isSubmitting={isCreatingCandidate}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};
